import type React from "react";
import { Box, Typography, Paper } from "@mui/material";

interface QuickActionCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  backgroundColor: string;
  iconColor: string;
  onClick: () => void;
}

const QuickActionCard: React.FC<QuickActionCardProps> = ({
  title,
  description,
  icon,
  backgroundColor,
  iconColor,
  onClick,
}) => {
  return (
    <Paper
      sx={{
        p: 3,
        cursor: "pointer",
        boxShadow: 0,
        backgroundColor,
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: 4,
        },
      }}
      onClick={onClick}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
        <Box
          sx={{
            color: iconColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography variant="h6" fontWeight="600" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default QuickActionCard;
